import React from 'react';
import fourSixIcon from "../../../../../../assets/images/icons/boundaries.svg";
import defendMsgIcon from "../../../../../../assets/images/icons/defend-msg.svg";
import batFaceMsgIcon from "../../../../../../assets/images/icons/bat-face-msg.svg";
import batDirectionMsgIcon from "../../../../../../assets/images/icons/bat-direction-msg.svg";
import backliftMsgIcon from "../../../../../../assets/images/icons/backlift-msg.svg";
import percentageIcon from "../../../../../../assets/images/icons/percentage.svg";
import horizontalBatMsgIcon from "../../../../../../assets/images/icons/horizontal-bat-msg.svg";
import efficiencyUpIcon from "../../../../../../assets/images/icons/up-icon.svg";
import timedShotIcon from "../../../../../../assets/images/icons/timed-shot.svg";
import playedMissedIcon from "../../../../../../assets/images/icons/played-missed.svg";

class InsightMessages extends React.Component {
    overallFeature(code, value) {
        var localText = ""
        var localImage = defendMsgIcon
        var codeLocal = parseInt(code)
        switch (codeLocal) {
            case 111:
                localText = "You swing and miss " + value + " times.";
                localImage = playedMissedIcon
                break;

            case 112:
                localText = "You hit the ball every time you swing the bat. Excellent!";
                localImage = fourSixIcon
                break;
            case 113:
                localText = "You hit " + value + "% of balls you faced. Good work!";
                localImage = percentageIcon
                break;
            case 114:
                localText = "You hit " + value + "% of balls you faced. Nice!";
                localImage = percentageIcon
                break;
            case 115:
                localText = "Your hit percentage is below hit percentage of Elite players.";
                localImage = percentageIcon
                break;

            case 121:
                localText = "" + value + "%  of shots were vertical bat swings. That’s good as it reduces risk of edges.";
                localImage = defendMsgIcon
                break;
            case 122:
                localText = "Your vertical bat swings were " + value + "% of the total swings. That's good if you are playing as per the length of the ball.";
                localImage = defendMsgIcon
                break;
            case 123:
                localText = "You played " + value + "% of shots with horizontal bat.";
                localImage = horizontalBatMsgIcon
                break;

            case 131:
                localText = "" + value + " of your shots were more than 90% efficient.";
                localImage = efficiencyUpIcon
                break;

            case 132:
                localText = "You timed " + value + "% of the shots played.";
                localImage = timedShotIcon
                break;

            default:

        }
        return [localImage, localText]
    }
    verticalFeature(code, value, verticalFlagText) {
        var localText = ""
        var localImage
        var codeLocal = parseInt(code)
        switch (codeLocal) {
            case 201:
                localText = "You defended " + value + "% of your vertical bat shots."
                localImage = defendMsgIcon
                break;
            case 202:
                localText = "" + value + "% of your vertical bat shots were hit to score runs."
                localImage = defendMsgIcon
                break;
            case 203:
                localText = "" + value + "% of your vertical bat shots were hit to score boundaries."
                localImage = fourSixIcon
                break;
            case 204:
                localText = "" + value + "% of your vertical bat shots were powerful hits."
                localImage = fourSixIcon
                break;
            case 205:
                localText = "" + value + "% of balls were hit hard to score runs."
                localImage = fourSixIcon
                break;
            case 206:
                localText = "You defended " + value + "% of the shots."
                localImage = defendMsgIcon
                break;

            //Sub Text
            case 211:
                verticalFlagText[0] = "High(" + value + "°)"
                return verticalFlagText
            // break;
            case 212:
                verticalFlagText[0] = "Medium(" + value + "°)"
                return verticalFlagText
            // break;
            case 213:
                verticalFlagText[0] = "Low(" + value + "°)"
                return verticalFlagText
            // break;

            case 221:
                localText = "Your average BackLift Angle is " + verticalFlagText[0] + " and is " + value + "% consistent. Excellent!"
                localImage = backliftMsgIcon
                break;
            case 222:
                localText = "Your average BackLift Angle is " + verticalFlagText[0] + " and is " + value + "% consistent."
                localImage = backliftMsgIcon
                break;
            case 223:
                localText = "Your average BackLift Angle is " + verticalFlagText[0] + " and is " + value + "% consistent. Elite players have consistency of more than 90%."
                localImage = backliftMsgIcon
                break;
            case 231:
                localText = "Your BackLift Angle for vertical shots is " + value + "% consistent. Good!"
                localImage = backliftMsgIcon
                break;
            case 232:
                localText = "Your BackLift Angle for vertical shots is " + value + "% consistent."
                localImage = backliftMsgIcon
                break;
            case 233:
                localText = "Your BackLift Angle for vertical shots is " + value + "% consistent. Elite players have more than 90% consistency in their vertical bat shots."
                localImage = backliftMsgIcon
                break;

            //Sub Text
            case 241:
                verticalFlagText[1] = "towards Stumps(" + value + "°)"
                return verticalFlagText
            // break;
            case 242:
                verticalFlagText[1] = "towards 1st Slip(" + value + "°)"
                return verticalFlagText
            // break;
            case 243:
                verticalFlagText[1] = "towards 2nd Slip(" + value + "°)"
                return verticalFlagText
            // break;
            case 244:
                verticalFlagText[1] = "towards 3rd Slip(" + value + "°)"
                return verticalFlagText
            // break;
            case 245:
                verticalFlagText[1] = "towards Gully(" + value + "°)"
                return verticalFlagText
            // break;
            case 246:
                verticalFlagText[1] = "" + value + "°"
                return verticalFlagText
            // break;
            case 247:
                verticalFlagText[1] = "towards leg side"
                return verticalFlagText
            // break;

            case 251:
                localText = "Your Bat Direction at start of the BackLift is " + verticalFlagText[1] + " and is " + value + "% consistent for vertical bat shots. Excellent!"
                localImage = batDirectionMsgIcon
                break;
            case 252:
                localText = "Your Bat Direction is " + value + "% consistent and mostly point " + verticalFlagText[1]
                localImage = batDirectionMsgIcon
                break;
            case 253:
                localText = "Your Bat Direction consistency is " + value + "%. For vertical swings your bat was pointing " + verticalFlagText[1]
                localImage = batDirectionMsgIcon
                break;
            case 254:
                localText = "Your Bat Direction is inconsistent. Elites have bat direction consistency of more than 90%."
                localImage = batDirectionMsgIcon
                break;
            case 255:
                localText = "Your Bat Direction is " + verticalFlagText[1] + " whereas elite players have Bat Direction towards keeper or pointing towards slips."
                localImage = batDirectionMsgIcon
                break;

            //Sub Text
            case 261:
                verticalFlagText[2] = "slightly open towards the off side(" + value + "°)"
                return verticalFlagText
            // break;
            case 262:
                verticalFlagText[2] = "open towards the off side(" + value + "°)"
                return verticalFlagText
            // break;
            case 263:
                verticalFlagText[2] = "open towards the leg side(" + value + "°)"
                return verticalFlagText
            // break;

            case 271:
                localText = "Your Bat Face is " + verticalFlagText[2] + " and is " + value + "% consistent. Excellent!"
                localImage = batFaceMsgIcon
                break;
            case 272:
                localText = "Your Bat Face is " + verticalFlagText[2] + " and is " + value + "% consistent for vertical shots."
                localImage = batFaceMsgIcon
                break;
            case 273:
                localText = "Your Bat Face for vertical shots is inconsistent."
                localImage = batFaceMsgIcon
                break;
            default:

        }
        return [localImage, localText]
    }
    horizontalFeature(code, value, horizontalFlagText) {
        var localText = ""
        var localImage
        var codeLocal = parseInt(code)
        switch (codeLocal) {
            case 301:
                localText = "You defended " + value + "% of your horizontal bat shots."
                localImage = horizontalBatMsgIcon
                break;
            case 302:
                localText = "" + value + "% of your horizontal bat shots were hit to score runs."
                localImage = horizontalBatMsgIcon
                break;
            case 303:
                localText = "" + value + "% of your horizontal bat shots were hit to score boundaries."
                localImage = fourSixIcon
                break;
            case 304:
                localText = "" + value + "% of your horizontal bat shots were powerful hits."
                localImage = fourSixIcon
                break;
            case 305:
                localText = "" + value + "% of the balls were hit to score runs."
                localImage = fourSixIcon
                break;
            case 306:
                localText = "You defended " + value + "% of the shots."
                localImage = horizontalBatMsgIcon
                break;


            //Sub Text
            case 311:
                horizontalFlagText[0] = "High(" + value + "°)";
                return horizontalFlagText
            // break;
            case 312:
                horizontalFlagText[0] = "Medium(" + value + "°)";
                return horizontalFlagText
            // break;
            case 313:
                horizontalFlagText[0] = "Low(" + value + "°)";
                return horizontalFlagText
            // break;

            case 321:
                localText = "Your average BackLift Angle is " + horizontalFlagText[0] + " and is " + value + "% consistent. Excellent!"
                localImage = backliftMsgIcon
                break;
            case 322:
                localText = "Your average BackLift Angle is " + horizontalFlagText[0] + " and is " + value + "% consistent."
                localImage = backliftMsgIcon
                break;
            case 323:
                localText = "Your average BackLift Angle is " + horizontalFlagText[0] + " and is " + value + "% consistent. Elite players have consistency of more than 90%."
                localImage = backliftMsgIcon
                break;
            case 331:
                localText = "Your BackLift Angle for horizontal shots is " + value + "% consistent. Good!"
                localImage = backliftMsgIcon
                break;
            case 332:
                localText = "Your BackLift Angle for horizontal shots is " + value + "% consistent."
                localImage = backliftMsgIcon
                break;
            case 333:
                localText = "Your BackLift Angle for horizontal shots is " + value + "% consistent. Elite players have more than 90% consistency in their horizontal bat shots."
                localImage = backliftMsgIcon
                break;

            //Sub Text
            case 341:
                horizontalFlagText[1] = "towards Stumps(" + value + "°)";
                return horizontalFlagText
            // break;
            case 342:
                horizontalFlagText[1] = "towards 1st Slip(" + value + "°)";
                return horizontalFlagText
            // break;
            case 343:
                horizontalFlagText[1] = "towards 2nd Slip(" + value + "°)";
                return horizontalFlagText
            // break;
            case 344:
                horizontalFlagText[1] = "towards 3rd Slip(" + value + "°)";
                return horizontalFlagText
            // break;
            case 345:
                horizontalFlagText[1] = "towards Gully(" + value + "°)";
                return horizontalFlagText
            // break;
            case 346:
                horizontalFlagText[1] = "" + value + "°";
                return horizontalFlagText
            // break;
            case 347:
                horizontalFlagText[1] = "towards leg side";
                return horizontalFlagText
            // break;

            case 351:
                localText = "Your Bat Direction at start of the BackLift is " + horizontalFlagText[1] + " and is " + value + "% consistent for horizontal bat shots. Excellent!"
                localImage = batDirectionMsgIcon
                break;
            case 352:
                localText = "Your Bat Direction is " + value + "% consistent and mostly point " + horizontalFlagText[1]
                localImage = batDirectionMsgIcon
                break;
            case 353:
                localText = "Your Bat Direction consistency is " + value + "%. For horizontal swings your bat was pointing " + horizontalFlagText[1]
                localImage = batDirectionMsgIcon
                break;
            case 354:
                localText = "Your Bat Direction is inconsistent. Elites have their Bat Direction consistency for more than 90%."
                localImage = batDirectionMsgIcon
                break;
            case 355:
                localText = "Your Bat Direction is " + horizontalFlagText[1] + " whereas elite players have Bat direction towards keeper or pointing towards slips."
                localImage = batDirectionMsgIcon
                break;

            //Sub Text
            case 361:
                horizontalFlagText[2] = "slightly open towards the off side(" + value + "°)";
                return horizontalFlagText
            // break;
            case 362:
                horizontalFlagText[2] = "open towards the off side(" + value + "°)";
                return horizontalFlagText
            // break;
            case 363:
                horizontalFlagText[2] = "open towards the leg side(" + value + "°)";
                return horizontalFlagText
            // break;

            case 371:
                localText = "Your Bat Face is " + horizontalFlagText[2] + " and is " + value + "% consistent. Excellent"
                localImage = batFaceMsgIcon
                break;
            case 372:
                localText = "Your Bat Face is " + horizontalFlagText[2] + " and is " + value + "% consistent for horizontal shots."
                localImage = batFaceMsgIcon
                break;
            case 373:
                localText = "Your Bat Face for horizontal shots is inconsistent."
                localImage = batFaceMsgIcon
                break;
            default:
        }
        return [localImage, localText]
    }
    render() {
        const feature = this.props.feature
        const featureData = this.props.featureData
        var msgData = ""
        var messageArray = []
        if (feature === 'overall') {
            for (var i = 0; i < featureData.length; i++) {
                msgData = this.overallFeature(featureData[i][0], featureData[i][1])
                if (msgData[1] !== "") {
                    messageArray.push(msgData)
                }
            }
        }
        var verticalBackliftFlagValue = ""
        var verticalBatDirectionFlagValue = ""
        var verticalBatFaceFlagValue = ""
        var verticalFlagText = [verticalBackliftFlagValue, verticalBatDirectionFlagValue, verticalBatFaceFlagValue]
        if (feature === 'vertical') {
            for (i = 0; i < featureData.length; i++) {
                msgData = this.verticalFeature(featureData[i][0], featureData[i][1], verticalFlagText)
                if (msgData.length === 3) {
                    // verticalFlagText = [...msgData]
                } else {
                    if (msgData[1] !== "") {
                        messageArray.push(msgData)
                    }
                }
            }
        }
        var horizontalBackliftFlagValue = ""
        var horizontalBatDirectionFlagValue = ""
        var horizontalBatFaceFlagValue = ""
        var horizontalFlagText = [horizontalBackliftFlagValue, horizontalBatDirectionFlagValue, horizontalBatFaceFlagValue]
        if (feature === 'horizontal') {
            for (i = 0; i < featureData.length; i++) {
                msgData = this.horizontalFeature(featureData[i][0], featureData[i][1], horizontalFlagText)
                if (msgData.length === 3) {
                    // horizontalFlagText = [...msgData]
                } else {
                    if (msgData[1] !== "") {
                        messageArray.push(msgData)
                    }
                }
            }
        }
        return (
            <div>
                {messageArray.map((message, index) =>
                    <div className="row" key={index} style={{ display: 'flex', alignItems: 'center', paddingBottom: '5px' }}>
                        <div className="col-sm-2">
                            <img src={message[0]} width="30px" alt='' />
                        </div>
                        <div className="col-sm-10" style={{ textAlign: 'left' }}>
                            <span>{message[1]}</span>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
export default InsightMessages;